import type { ReactNode } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '@/hooks/useAuth';

interface RequireBootstrapAdminProps {
  children?: ReactNode;
}

export default function RequireBootstrapAdmin({ children }: RequireBootstrapAdminProps) {
  const { user, isLoading } = useAuth();

  if (isLoading) return null;

  if (!user?.isBootstrapAdmin) {
    return <Navigate to="/" replace />;
  }

  return children ?? <Outlet />;
}
